/**
 * True para os modelos de rodízio de duplas (competidor individual, grupo de
 * tamanho FIXO com tabela whist pré-gerada, parceria rotativa): REI_RAINHA e SUPER_8.
 *
 * Fonte única do predicado que hoje aparece inline em vários componentes
 * (`modeloDisputa === 'REI_RAINHA' || modeloDisputa === 'SUPER_8'`).
 */
export function isRodizio(modeloDisputa?: string | null): boolean {
  return modeloDisputa === 'REI_RAINHA' || modeloDisputa === 'SUPER_8';
}
